import { Image } from "./image";
import { apiBaseAssets } from "../config/api";
import { useHistory } from "react-router";
import lc from "../utils/language";
export const Gallery = ({ data, isRtl }) => {
  //console.log(data);
  const history = useHistory();
  return (
    <div
      id="portfolio"
      className="text-center"
      style={{ backgroundColor: "none" }}
    >
      <div className="container" style={{ background: 'none' }}>
        <div className="section-title" style={{ background: 'none' }}>
          <h2 style={{ fontFamily: isRtl ? "amiriBold" : "Merriweather" }}>
            {data[lc("title", isRtl)]}
          </h2>
          <p style={{ fontFamily: isRtl ? "amiriRegular" : "Open Sans", color: '#7FB6FF' }}>
            {data[lc("subTitle", isRtl)]}
          </p>
        </div>
        <div className="row">
          <div className="portfolio-items" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
            {data.projects.length > 0
              ? data.projects.map((d, i) => (
                <div
                  key={d._id}
                  className="col-sm-6 col-md-39 col-md-39"
                  style={{ cursor: "pointer" }}
                  onClick={() => history.push("/project/" + d._id)}
                >
                  <Image
                    isRtl={isRtl}
                    title={d[lc("title", isRtl)]}
                    largeImage={apiBaseAssets + d.background}
                    smallImage={apiBaseAssets + d.background}
                  />
                </div>
              ))
              : "Loading..."}
          </div>
        </div>
      </div>
    </div>
  );
};
